import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSubscriptionsContext } from "@/contexts/subscriptions";
import DatePicker from "@/shared/components/DatePicker/DatePicker";

export const SubscriptionsDatePicker = ({
  date,
  minDate,
  onDateChange,
}) => {
  const {
    fetchMonthData,
    calendar
  } = useSubscriptionsContext();

  useEffect(() => {
    fetchMonthData(date, true);
  }, [fetchMonthData]);

  return (
    <DatePicker
      maxDate={new Date()}
      calendar={calendar}
      onFetchMonthData={fetchMonthData}
      date={date}
      minDate={minDate}
      onDateChange={onDateChange}
    />
  );
};

SubscriptionsDatePicker.propTypes = {
  date: PropTypes.object,
  minDate: PropTypes.object,
  onDateChange: PropTypes.func,
};